<template>
<div v-show="showComponent">
  <RewardsTitle title="Loyalty Program" />

  <v-carousel hide-delimiters :style="{ height: `${carouselHeight}px !important`}">
    <v-carousel-item v-for="(reward, i) in rewardsList" :key="reward.rewardNameString">
      <v-sheet height="100%" color="secondary" tile>
        <div class="mainTitle">
          - {{ reward.nameString || reward.rewardName }} -
        </div>

        <div class="subTitle">
          <div v-if="'rewardNameString' in reward">
            {{ reward.rewardNameString }}
            <PunchCard v-show="false" :punchCard="reward" />
          </div>
          <div v-else-if="'referralNameString' in reward">
            {{ reward.referralNameString }}
            <ReferralCard v-show="false" :referralLink="referralLink" :referral="reward" />
          </div>
          <div v-else-if="'redeemPoints' in reward">
            {{ $vuetify.t('$vuetify.account.rewards.points') }}: {{ reward.redeemPoints | comma }}

            <RewardOptionsCard v-show="false" :rewardOption="reward" />
          </div>
        </div>

        <v-btn color="primary" @click="handleClick(reward)">
          {{ getButtonText(reward) }}
        </v-btn>
      </v-sheet>
    </v-carousel-item>
  </v-carousel>
</div>
</template>

<script>
  import get from 'lodash/get';

  import { mapMutations, mapActions, mapGetters } from 'vuex'
  import { matchTranslation } from "@/services/util.service"
  import { isNullOrEmpty } from '@/services/util.service';

  import PunchCard from '@/components/Common/PunchCard'
  import RewardOptionsCard from "@/components/RewardsOptions/RewardOptionsCard"

  import RewardsTitle from "./RewardsTitle"
import ReferralCard from './ReferralCard.vue';

  export default {
    components: { PunchCard, RewardOptionsCard, RewardsTitle, ReferralCard },

    data() {
      return {
        rewardInView: 0,
        referralLink: ''
      }
    },
    mounted() {
      const currentUrl = window.location.href;
      const url = new URL(currentUrl);
      const pathnameParts = url.pathname.split('/');

      const groupIndex = pathnameParts.findIndex(part => part.includes('G')); 

      if (groupIndex !== -1) {
        const groupPageUrl = `${url.origin}${pathnameParts.slice(0, groupIndex + 1).join('/')}`;
        this.referralLink = `${groupPageUrl}?referrer=${this.getCustomer.id}`;
      }
    },
    computed: {
      showComponent() {
        return !isNullOrEmpty(this.rewardsList)
      },
      carouselHeight() {
        const reward = this.rewardsList[this.rewardInView];
        if (reward) {
          return 'referralNameString' in reward ? 250 : 170;
        } else {
          170
        }
      },
      punchCards() {
        return get(this.getRewards, 'punchCards', [])
      },
      redeemOptions() {
        return get(this.getRewards, 'redeemOptions', [])
      },
      rewardsList() {
        const store = this.getStore;
        const rewardsSettings = store && store.settings && store.settings.rewardsSettings;

        if (store && rewardsSettings && rewardsSettings.referralSettings) {
          const { referralSettings, supportsReferralBonus } = rewardsSettings;

          const title = referralSettings.title && referralSettings.title.translations 
            ? matchTranslation(referralSettings.title.translations) 
            : null;
          
          const description = referralSettings.description && referralSettings.description.translations 
            ? matchTranslation(referralSettings.description.translations) 
            : null;

          const referral = {
            id: "referral",
            isItem: false,
            onlineRedeemable: true,
            rewardName: title || "Earn Rewards By Referring Friends",
            referralNameString: description || "Invite your friends to enjoy our delicious meals, and you'll both earn 100 points! Share the love and start earning rewards today"
          };

          return [
            ...(supportsReferralBonus ? [referral] : []),
            ...(this.punchCards || []),
            ...(this.redeemOptions || [])
          ].filter(Boolean);
        }

        return [
          ...(this.punchCards || []),
          ...(this.redeemOptions || [])
        ].filter(Boolean);
      },

      ...mapGetters([
        'isLoggedIn',
        'getStore',
        'getCustomer',
        'getRewards',
        'getPunchCards'
      ])
    },

    methods: {
      getButtonText(reward) {
        return 'referralNameString' in reward ? this.$vuetify.t('$vuetify.common.referralButtonText') : this.$vuetify.t('$vuetify.common.clickToRedeem');
      },
      handlePunchCard(punchCard) {
        if (this.isLoggedIn) {
          const matched = this.getPunchCards.find(p => p.id == punchCard.id)

          // Only manipulate the active punchCard if they have enough points and aren't already using it
          if (this.$root.$refs.punchCard.showPunchCard(matched)) {
            this.showSnack({
              text: this.$vuetify.t('$vuetify.account.rewards.availableInCart'),
              color: 'secondary'
            })

            // On mobile, show the cart to see the users rewards
            if (this.$vuetify.breakpoint.smAndDown)
              this.$bus.$emit('toggleCart', true)
          } else {
            this.showSnack({
              text: this.$vuetify.t('$vuetify.account.rewards.missingPoints', [this.findMissing(matched)]),
              color: 'error'
            })
          }
        } else {
          this.showSnack({
            text: 'Please login to see your rewards',
            color: 'secondary'
          })

          // On mobile, showing the cart makes both the login and rewards cards visible
          if (this.$vuetify.breakpoint.smAndDown)
            this.$bus.$emit('toggleCart', true)
          else
            this.setLoginDialog(true)
        }
      },
      handleRedeemable(reward) {
        if (this.isLoggedIn) {
          this.$root.$refs.redeemables.openConfig(reward)
        } else {
          this.showSnack({
            text: 'Please login to see your rewards',
            color: 'secondary'
          })

          // On mobile, showing the cart makes both the login and rewards cards visible
          if (this.$vuetify.breakpoint.smAndDown)
            this.$bus.$emit('toggleCart', true)
          else
            this.setLoginDialog(true)
        }
      },
      handleReferral(reward) {
        this.$root.$refs.referral.openDialog();
      },
      handleClick(reward) {
        if (reward.id=='referral') {
          this.handleReferral(reward)
        } else {
          const isPunchCard = !isNullOrEmpty(this.punchCards) && !!this.punchCards.find(_punch => _punch.code == reward.code)

          // TODO: This isn't totally reliable yet but I don't want to spend too much time until the ui is approved
          if (isPunchCard) {
            this.handlePunchCard(reward)
          } else {
            this.handleRedeemable(reward)
          }
        }
      },

      ...mapActions([ 'showSnack' ]),
      ...mapMutations([ 'setLoginDialog' ])
    }
  }
</script>

<style scoped>
  .mainTitle {
    font-size: var(--text-size-2);
  }
  .subTitle {
    font-size: var(--text-size-1);
    margin: 10px auto;
  }

  .v-sheet {
    padding: 20px 0px 0px !important;
  }
  h1 {
    font-size: 46px;
  }
</style>
